// noinspection JSUnresolvedReference

import '../sass/style.scss';

function getCity(city_id) {
    const cities = JSON.parse($('#cities').text());
    return cities.find((city) => city.id === parseInt(city_id));
}

function getCityOther() {
    const cities = JSON.parse($('#cities').text());
    return cities.find((city) => city.name === 'Другой');
}

function setSalary(city, cityOther) {
    let $salary = $('#salary');
    const template = $salary.attr('data-template');
    const price = (city.price) ? city.price : cityOther.price;

    let html = template;
    html = html.replace('{price}', Intl.NumberFormat('ru-RU', {'currency': 'RUB'}).format(price) + ' ₽');
    if (city.name !== 'Другой') {
        html = html.replace('{city}', lvovich.cityIn(city.name));
    }
    else {
        html = html.replace(' в {city}', '');
    }

    $salary.show();
    $salary.html(html);
}

$.modal.defaults = {
    showClose: false,
    escapeClose: true,
}

$(document).ready(() => {
    $('[data-modal^="#"]').click(function () {
        const $target = $(this).attr('data-modal');
        $($target).modal();
    });
    $('.modal-close').click(() => {
        $.modal.close();
    })
    $('a').click(function (event) {
        const href = $(this).attr('href');
        if (href.length > 2 && href[0] === '#') {
            event.preventDefault();
            $('html,body').animate({scrollTop: $(href).offset().top}, 500);
        }
    })

    if ($('#section-main').length) {
        new Inputmask('+7 (999) 999-99-99').mask($('#id_phone'));
        
        const cityOther = getCityOther();
        const selectCity = customSelect('.select-city');
        const select1 = selectCity.find((item) => item.select.id === 'id_city');
        const select2 = selectCity.find((item) => item.select.id === 'select-city');

        let city = getCity(select1.value)
        if (city) {
            setSalary(city, cityOther);
            select2.value = city.id;
        }

        $('#btn-select-city').click(() => {
            city = getCity(select2.value)
            if (city) {
                setSalary(city, cityOther);
                select1.value = city.id;
                $('#location-city').text(city.name);
            }
            $.modal.close();
        })

        $('#form').submit(function (event) {
            let $form = $(this);
            const data = $(this).serialize();
            const $button = $(this).find('button[type=submit]');

            event.preventDefault();
            $button.prop('disabled', true);
            $.ajax({
                type: 'POST',
                data: data,
            }).done((response) => {
                if (response.success) {
                    $('#modal-success').modal();
                    $form.find('input').val('');
                    select1.value = select2.value;
                }
                else {
                    $('#modal-error').modal();
                }
            }).fail(() => {
                $('#modal-error').modal();
            }).always(() => {
                $button.prop('disabled', false);
            })
        })
    }
});
